<div class="pr-owner-share" [ngClass]="{ 'pr-input-disabled': disabled }">
  @if (label) {
    <span class="pr-input-label">
      {{ label }}
      @if (
        required ||
        (control &&
          control.validator &&
          control.validator({}) &&
          control.validator({}).required)
      ) {
        <em> *</em>
      }
      @if (tooltipButton) {
        <pr-icon
          class="tooltip-icon"
          name="sp-tooltip-icon"
          width="16"
          viewBoxWidth="18"
          viewBoxHeight="18"
          [tooltip]="tooltipButton"
        ></pr-icon>
      }
    </span>
  }

  @if (availableOptions.length && !disabled) {
    <pr-select-form
      class="pr-owner-share-add"
      [options]="addSelectOptions"
      [value]="null"
      placeholder="Ajouter un détenteur…"
      (onChange)="onAdd($event)"
    ></pr-select-form>
  }

  @if (values.length) {
    <div class="pr-owner-share-rows">
      @for (owner of values; track owner.ownerId) {
        <div class="pr-owner-share-row">
          <span class="pr-owner-share-name">{{ labelFor(owner.ownerId) }}</span>
          <span class="pr-owner-share-pct">
            <input
              type="number"
              step="any"
              min="0"
              [ngModel]="toDisplayPct(owner.share)"
              (ngModelChange)="onShareChange(owner.ownerId, $event)"
              [disabled]="disabled"
              aria-label="Part de détention"
            />
            <span class="suffix">%</span>
          </span>
          @if (!disabled) {
            <button
              type="button"
              class="pr-owner-share-remove"
              (click)="onRemove(owner.ownerId)"
              [attr.aria-label]="'Retirer ' + labelFor(owner.ownerId)"
            >
              &times;
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <div class="pr-owner-share-empty">Aucun détenteur sélectionné.</div>
  }

  @if (values.length) {
    <div class="pr-owner-share-foot">
      <span
        class="pr-owner-share-total"
        [ngClass]="{ ok: totalPct === 100, over: isOver }"
      >
        Total : {{ totalPct }} %
      </span>
      @if (!disabled) {
        <button
          type="button"
          class="pr-owner-share-redis"
          (click)="redistributeEqually()"
        >
          Répartir équitablement
        </button>
      }
      @if (isOver) {
        <span class="pr-owner-share-err">
          La somme des parts ne peut pas dépasser 100 %.
        </span>
      }
    </div>
  }

  <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
</div>
